export enum ItemsHeader {
  ALL = "ALL",
  BATCH = "BATCH",
  FLOCK = "FLOCK",
}

export enum Gender {
  MALE = "male",
  FEMALE = "female",
}

export enum Aptitude {
  CUT = "cut",
  MILK = "milk",
}
